import { ExportOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { createStyles } from 'antd-style'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AnnouncementListTitleRenderProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    [`& .anticon-export`]: {
      opacity: 0,
      transition: 'opacity 0.3s'
    },
    [`&:hover .anticon-export`]: {
      opacity: 1
    }
  },
  icon: {
    color: token.colorTextTertiary
  }
}))

export const AnnouncementListTitleRender = ({
  createPath,
  detailPath,
  record: { id, code }
}: AnnouncementListTitleRenderProps) => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <NavigateButton
        plain
        underline
        type='text'
        to={stringifyUrl({
          url: detailPath,
          query: { id }
        })}
      >
        {code}
      </NavigateButton>
      <Tooltip title='复制文章' trigger='hover'>
        <NavigateButton
          newtab
          icon={<ExportOutlined className={styles.icon} />}
          size='small'
          type='text'
          to={stringifyUrl({
            url: createPath,
            query: { id }
          })}
        />
      </Tooltip>
    </div>
  )
}
